{
  "title": "Справка",
  "howItWorks": "Как это работает",
  "more": "Что это?",
  "readMore": "Подробнее"
}
